module.exports = __webpack_public_path__ + "static/media/card4_5.a30515ee.png";